import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Pencil.svg?component
var Pencil_exports = /* @__PURE__ */ __exportAll({
	default: () => Pencil_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M17 3a2.85 2.85 0 0 1 2.064-1.007 2.87 2.87 0 0 1 2.14.834 2.83 2.83 0 0 1 .825 2.131A2.8 2.8 0 0 1 21 7L7.5 20.5 2 22l1.5-5.5z" }, null, -1)])]);
}
var Pencil_default = { render: render$1 };
//#endregion
export { Pencil_exports, Pencil_default as default, render$1 as render };

//# sourceMappingURL=Pencil.svg_component.js.map